import React, { useRef, useState, useEffect } from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = ({ onDone }) => {
  const contentRef = useRef(null);
  const [scrolledToBottom, setScrolledToBottom] = useState(false);
  const isModal = typeof onDone === 'function';

  useEffect(() => {
    if (!isModal) {
      return;
    }

    setScrolledToBottom(false);
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [isModal]);

  const handleScroll = () => {
    const el = contentRef.current;
    if (el) {
      const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 5;
      setScrolledToBottom(atBottom);
    }
  };

  return (
    <div
      className={`terms-modal-outer ${
        isModal ? 'terms-modal-outer--dialog' : 'terms-modal-outer--page'
      }`}
    >
      <div
        className={`terms-container ${isModal ? 'terms-scrollable' : 'terms-page-flow'}`}
        ref={contentRef}
        onScroll={isModal ? handleScroll : undefined}
        tabIndex={isModal ? 0 : undefined}
      >
        <h1>Terms and Conditions</h1>
        <p>Welcome to <span className="brand-name-gold">Panchali Jewels</span>! Please read these terms and conditions carefully before using our website.</p>
        <h2> Acceptance of Terms</h2>
        <p>By accessing or using this Website or placing an order, you affirm that you are at least 18 years of age and legally capable of entering into a binding contract. If you do not agree to these Terms, you must not use the Website..</p>
        <h2>Products And Pricing</h2>
        <p>We strive to ensure all product descriptions, pricing, and availability are accurate. However, errors may occur, and we reserve the right to correct any inaccuracies and to refuse or cancel any orders placed for items listed with incorrect pricing or availability.</p>
        <h2> User Responsibilities</h2>
        <p>You agree not to use the Website for any unlawful purpose, interfere with others’ use, or attempt to breach security or gain unauthorized access to user accounts, servers, or data.</p>
        <h2> Intellectual Property</h2>
        <p>All content on this Website, including logos, images, text, graphics, product photos, and software, is the property of <span className="brand-name-gold">Panchali Jewels</span> and is protected under applicable copyright and intellectual property laws. Unauthorized use is strictly prohibited.</p>
        <h2>ORDER ACCEPTANCE</h2>
        <p>Your receipt of an electronic or other form of order confirmation does not signify our acceptance of your order. We reserve the right to accept or decline your order for any reason, including suspected fraud or unavailability of products.</p>
        <h2> Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, <span className="brand-name-gold">Panchali Jewels</span> shall not be liable for any direct, indirect, incidental, punitive, or consequential damages arising from your use or inability to use the Website or our products.</p>
        <h2>THIRD-PARTY LINKS</h2>
        <p>Our Website may contain links to third-party websites for your convenience. We do not control, endorse, or assume responsibility for the content, privacy policies, or practices of any third parties.</p>
        <h2>DISCLAIMER OF WARRANTIES</h2>
        <p>All products and services are provided “as is” and “as available” without warranties of any kind, either express or implied, including merchantability, fitness for a particular purpose, or non-infringement.</p>
        <h2> INDEMNIFICATION</h2>
        <p>You agree to indemnify and hold harmless <span className="brand-name-gold">Panchali Jewels</span>, its affiliates, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses arising from your breach of these Terms or misuse of the Website.</p>
        <h2> MODIFICATIONS</h2>
        <p>We reserve the right to update or modify these Terms at any time without prior notice. The updated Terms will be effective upon posting to the Website.</p>
        <h2>GOVERNING LAW</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of [Your State/Country], without regard to its conflict of law provisions. Any disputes shall be subject to the exclusive jurisdiction of the courts of [Your Jurisdiction].</p>
        <h1>📦 RETURN, REFUND & EXCHANGE POLICY</h1>
        <p>We at <span className="brand-name-gold">Panchali Jewels</span> want you to be completely satisfied with your purchase. Please review our return and exchange policy below. <br /><br />
1. RETURN ELIGIBILITY
You may return an eligible item within 30 days of the date of delivery, provided the item: <br /> <br />
•	Is unworn and in original condition. <br /> <br />
•	Is returned with original packaging, tags, and invoice. <br /> <br />
•	Has not been customized, engraved, or made-to-order. <br /> <br />
2. NON-RETURNABLE ITEMS
The following items are non-returnable and non-refundable:
•	Personalized or custom-made jewellery.
•	Engraved pieces.
•	Gift cards.
•	Gold coins, idols, perfumes, or candles. <br /> <br />
3. REFUND PROCESS
Once we receive and inspect the returned item:
•	You will receive a refund to your original payment method within 15 business days.
•	If approved, we will notify you via email.
•	If the item does not pass inspection, we reserve the right to reject the return. <br /> <br />
4. EXCHANGE POLICY
•	Exchanges are accepted within 30 days from the delivery date.
•	Exchange items must meet the same conditions as returnable items.
•	Any price difference must be settled at the time of exchange. <br /> <br />
5. RETURN SHIPPING
•	Return shipping is free for domestic orders over ₹1,999 (subject to location and item type).
•	For other returns, shipping costs must be borne by the customer.
•	For damaged/incorrect items, return shipping is fully covered by us. <br /> <br />
6. INTERNATIONAL ORDERS
•	Returns on international orders are accepted within 30 days.
•	Customers are responsible for international shipping and customs charges, if applicable. <br /> <br />
7. HOW TO INITIATE A RETURN
Please email us at [support@yourdomain.com] with your order number, reason for return, and photos (if applicable). We will provide return instructions and a shipping label (if eligible). <br /> <br />
8. RESTOCKING FEES
No restocking fees apply unless otherwise stated for specific categories or sale items. <br /> <br />
</p>
        <h2> Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at:<br />
<span className="brand-name-gold">Panchali Jewels</span><br />
Email: [support@yourdomain.com]
Phone: [+91-XXXXXXXXXX]
</p>
        {isModal && (
          <button
            type="button"
            className="terms-done-btn"
            onClick={onDone}
            disabled={!scrolledToBottom}
          >
            Done
          </button>
        )}
      </div>
    </div>
  );
};

export default TermsAndConditions;
// You can use this component as a page or in a modal. For routing, add a route like:
// <Route path="/terms" element={<TermsAndConditions />} /> 
